<div class="bulk-verify-container" [formGroup]="cardsForm">
    <div class="page-header-container">
        <div class="navigation">
            <a (click)="navigateBack()" class="text-title-2 back-ref">
                {{(navigationState | navigatedFrom : 'Home' : '/dashboard')?.name}}
            </a>
            <div class="text-title-2 header">
                Bulk Confirm
            </div>
        </div>
        <div class="page-subheader-container">
            <div class="subheader">
                <img src="assets/icons/icon-exclamation-circle-green.svg" class="mr-1"/>
                <span class="subheader-wording">You have {{getTransactionsToVerifyCount()}} pending transactions ready for confirmation</span>
            </div>
            <div class="search-container" >
                <app-search-input class="search" [class.shrunk]="isSearchShrunk"
                    [formControl]="cardsForm.controls.search"
                    [color]="SearchInputColorEnum.Green"
                    [hideDropdown]="true"
                    [placeholder]="'Search by NDC, drug name, Rx # or patient name'"
                    [loading]="(loading$ | async) === true"
                    (click)="isSearchShrunk = false"
                    (searchBlurred)="searchInputBlurred()"
                    (searchCleared)="searchCleared()"
                    [isShrunk]="isSearchShrunk"
                ></app-search-input>
            </div>
        </div>
        <div class="filters">
            <div class="period-picker-container" [ngClass]="{'active': isTrDateDropdownOpened}">
                <app-date-filter
                  [period]="cardsForm.get('period')" 
                  [customPeriod]="cardsForm.get('customPeriod')"
                  [isLoading]="loading$ | async"
                  label="Transaction Date/Time"
                  (dropdownOpened)="isTrDateDropdownOpened = true"
                  (dropdownClosed)="isTrDateDropdownOpened = false"
                  >
                </app-date-filter>
              </div>
        
              <app-multiselect-dropdown formControlName="statuses"
                                        id="statuses"
                                        [ngClass]="{'active': isStatusesDropdownOpened}"
                                        [label]="'Status'"
                                        [placeholder]="'All Statuses'"
                                        (dropDownOpened)="multiselectOpened('statusItemsShowLimit', 'isStatusesDropdownOpened')"
                                        (dropDownClosed)="multiselectClosed('statusItemsShowLimit', 'isStatusesDropdownOpened')"
                                        [data]="statuses"
                                        [settings]="statusListSettings"
                                        [itemsLimit]="statusItemsShowLimit"
                                        [loading]="loading$ | async"
                                        (tabEnterEvent)="focusMultiOptionalDropdown('pharmacistsMultiOptionalDropdown')"
                                        #statusesMultiOptionalDropdown
              ></app-multiselect-dropdown>
              <app-multiselect-dropdown formControlName="pharmacists"
                                        id="pharmacists"
                                        [ngClass]="{'active': isPharmacistsDropdownOpened}"
                                        [label]="'Pharmacist'"
                                        [placeholder]="'All pharmacists'"
                                        (dropDownOpened)="multiselectOpened('pharmacistItemsShowLimit', 'isPharmacistsDropdownOpened')"
                                        (dropDownClosed)="multiselectClosed('pharmacistItemsShowLimit', 'isPharmacistsDropdownOpened')"
                                        [data]="pharmacists"
                                        [settings]="pharmacistListSettings"
                                        [itemsLimit]="pharmacistItemsShowLimit"
                                        [loading]="loading$ | async"
                                        (tabEnterEvent)="focusMultiOptionalDropdown('schedulesMultiOptionalDropdown')"
                                        #pharmacistsMultiOptionalDropdown
              ></app-multiselect-dropdown>
              <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
                class="schedules"
                label="Schedule"
                [selectedItemsBadgeLimitCount]="3"
                [control]="cardsForm.controls.schedules">
            </app-schedules-filter>
            <app-inventory-locations-dropdown *ngIf="inventoryLocationsEnabled$ | async"
                class="w-full ml-2"
                label="From Location"
                [formControl]="cardsForm.controls.inventoryLocationId"
                [excludeOptions]="locationsToExclude"
            ></app-inventory-locations-dropdown>
        </div>
    </div>
    
    <div class="transaction-cards-container">
        <table class="table-primary">
            <thead>
            <tr class="header">
                <th (click)="sortByColumn('rxNumber')" class="text-left sort rx" scope="col">
                    Rx #
                    <img [class.asc]="tableColumns.rxNumber" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th (click)="sortByColumn('patientName')" class="text-left sort patient" scope="col">
                    Patient
                    <img [class.asc]="tableColumns.patientName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th (click)="sortByColumn('statusCodeDate')" class="text-left sort date" scope="col">
                    Date/Time
                    <img [class.asc]="tableColumns.statusCodeDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
                        alt="asc" />
                </th>
                <th (click)="sortByColumn('friendlyName')" class="text-left sort drug" scope="col">
                    Drug
                    <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
                        alt="asc" />
                </th>
                <th (click)="sortByColumn('startingQuantity')" class="text-right sort inventory-value" scope="col">
                    Starting
                    <img [class.asc]="tableColumns.startingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th (click)="sortByColumn('addedQuantity')" class="text-right sort inventory-value" scope="col">
                    Count
                    <img [class.asc]="tableColumns.addedQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th (click)="sortByColumn('endingQuantity')" class="text-right sort inventory-value" scope="col">
                    On-Hand
                    <img [class.asc]="tableColumns.endingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th (click)="sortByColumn('similarOnHand')" class="text-right sort inventory-value" scope="col">
                    SOH
                    <img [class.asc]="tableColumns.similarOnHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc" />
                </th>
                <th class="text-right sort controls-col" scope="col">
                    <!--Controls-->
                </th>
            </tr>
            </thead>
            <tbody #tbody>
              <ng-container formArrayName="transactions" *ngFor="let rowData of cardsForm?.controls?.transactions?.value; let i = index; trackBy: trackByIndex">
                <div class="table-row-wrapper" [class.hidden]="!rowData.shouldShow" [class.filtered-out]="rowData.filteredOut">
                    <tr class="table-row" [formGroupName]="i" >
                        <th class="text-left rx" scope="row">
                            {{getRxNumber(rowData)}}
                        </th>
                        <th class="text-left patient patient-name">
                            {{rowData?.patientName}}
                        </th>
                        <td class="text-left date tr-date-col">
                            <div class="date-picker-container">
                                <app-datepicker-input [tabInd]="0"
                                    pickerType="both"
                                    [initialValue]="rowData?.statusCodeDate"
                                    formControlName="transactionDateDisplayValue"
                                    (dateTimeChange)="dateTimeChanged($event, i)"
                                    [dateMax]="now()"
                                    calendarPosition="right"
                                    [id]="i"
                                    #transactionDatePicker>
                               </app-datepicker-input>
                            </div>
                        </td>
                        <td class="text-left drug">
                        <div class="heading">
                            {{rowData?.friendlyName}}
                        </div>
                        <div class="secondary">
                            {{rowData?.packageNdc}}
                        </div>
                        </td>
                    
                        <td class="text-right inventory-value">{{rowData?.startingQuantity | number}}</td>
                        <td class="text-right inventory-value">{{rowData?.addedQuantity | number}}</td>
                        <td class="text-right inventory-value">{{rowData?.endingQuantity | number}}</td>
                        <td class="text-right inventory-value">{{rowData?.availableSOH | number}}</td>
                        <td class="controls-col">
                            <div class="controls">
                                <app-button *ngIf="transactionsIntegrationType === IntegrationTypeEnum.LibertyRx"
                                    customClasses="px-3"
                                    [minWidth]="0"
                                    [minHeight]="34"
                                    icon="icon-refresh2"
                                    [iconPosition]="ButtonIconPositions.Center"
                                    subStyle="white"
                                    (clicked)="refresh(i)"
                                >
                                </app-button>
                                    <app-button 
                                    customClasses="px-3"
                                    [minWidth]="0"
                                    [minHeight]="34"
                                    icon="icon-exclude"
                                    [iconPosition]="ButtonIconPositions.Center"
                                    subStyle="white-with-red-border"
                                    (clicked)="excludeTransaction(i)"
                                >
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </div>
                  
                </ng-container>
            </tbody>
          </table>

          <div class="footer">
            <div class="flex flex-row">
                <div class="label">
                    {{getTransactionsToVerifyCount()}} Transactions
                </div>
                <div *ngIf="hiddenTransactions?.length"
                    class="flex flex-row text-sm leading-5">
                    <img class="ml-4 mr-4" src="assets/icons/icon-vertical-divider.svg"/>
                    <div class="excluded">{{hiddenTransactions.length}} excluded</div>
                    <div class="restore" (click)="restoreExcluded()">Restore</div>
                </div>
                
            </div>
            <app-button 
              [text]="'Confirm ' + getTransactionsToVerifyCount() + ' Transactions'"
              customClasses="px-4"
              [minWidth]="0"
              class="verify"
              [disabled]="cardsForm.invalid || getTransactionsToVerifyCount() === 0 || (loading$ | async)"
              [loading]="loading$ | async"
              (clicked)="showPin()"
              
            >
            </app-button>
          </div>

    </div>
</div>

<app-dialog
  [showHeader]="true"
  [header]="'Cannot Change to this Transaction Date'"
  [subHeader]="cannotUpdateTrDateText + '  Please choose a different transaction date or exclude the transaction from bulk confirm.'"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="showCannotUpdateTransactionDate">
    <div class="flex justify-end">
        <app-button customClasses="px-4" 
            [text]="'Ok'" class="save-btn" 
            [minWidth]="50"
            (click)="showCannotUpdateTransactionDate = false">
        </app-button>
    </div>
</app-dialog>

<app-pill-loader-full-screen *ngIf="loading$ | async"></app-pill-loader-full-screen>


<app-dialog *ngIf="hubService.bulkVerifyInitiated$ | async; let initiator"
  [showHeader]="true"
  header="Already in progress"
  [subHeader]="initiator?.firstName + ' ' + initiator?.lastName + ' has already initiated the action'"
  [maxWidth]="490"
  [headerIcon]="'warning'"
  [show]="true"
>
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="close()" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>
